const sign = {
  brkey: "",
  inspectionId: "",
  signType: "",
  farAdvanceCond: "",
  farSiteCond: "",
  updateDateTime: new Date().toISOString(),
  nearAdvanceCond: "",
  nearSiteCond: "",
  notes: "",
  signMessage: "",
  signNeeded: "",
  updateUserId: "",
};
export default sign;
